export const GET_RATING_CODES_SUCCESS = 'GET_RATING_CODES_SUCCESS';

export const getRatingCodesSuccess = ({ ratingCodes }) => ({
    type: GET_RATING_CODES_SUCCESS,
    payload: { ratingCodes },
});
